export const CONFIG = Object.freeze({
  presentation: {
    assetConcurrency: 6,
    preloadSlides: 1,
    minFontSize: 12,
    minAtomicFontSize: 10,
    maxFontSize: 32,
    paginationFontSize: 24,
  },
});
